import React, { useState } from 'react';
import { withRouter }      from 'react-router-dom';
import { deviceDetect }    from "react-device-detect";

import Link                  from '@material-ui/core/Link';
import Grid                  from '@material-ui/core/Grid';
import CircularProgress      from '@material-ui/core/CircularProgress';
import Snackbar              from 'components/snackbar';
import Button                from 'components/button';

function Component (props) {
	let [email, setEmail]       = useState ('');
	let [password, setPassword] = useState ('');
	let [loading, setLoading]   = useState (false);
	let [open, setModal]        = useState (false);
	let [alertDesc, setDesc]    = useState ('');
	let [type, setModalType]    = useState ('warn');

	let login = async () => {
		if (!email) {
			setDesc ('Enter Email address');
			setModalType ('warn');
			setModal (true);
			return;
		}

		/*
		 *if (!validateEmail (email)) {
		 *    setDesc ('Invalid email address');
		 *    setModal (true);
		 *    return;
		 *}
		 */
		
		if (!password) {
			setDesc ('Enter Password');
			setModalType ('warn');
			setModal (true);
			return;
		}

		try {
			setLoading (true);

			const res = await postData('/auth/login' + window.location.search, {
				deviceInfo : deviceDetect (),
				username   : email,
				password   : password
			});

			if (res.status === 500)
				throw res;
			
			if (res.redirected)
				window.location.replace(res.url);
		}
		catch (err) {
			/* Not sure if this is correct, will check later */
			let _err = await err.json ();
			let msg  = _err.msg;

			if (msg === 'user name or password mismatch')
				msg = 'User name or password mismatch.';

			setDesc (msg);
			setModalType ('error');
			setModal (true);
		}

		setLoading (false);
	}

	async function postData(url = '', data = {}) {
		// Default options are marked with *
		const response = await fetch(url, {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, *cors, same-origin
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, *same-origin, omit
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
				// 'Content-Type': 'application/x-www-form-urlencoded',
			},
			redirect: 'follow', // manual, *follow, error
			referrer: 'no-referrer', // no-referrer, *client
			body: JSON.stringify(data) // body data type must match "Content-Type" header
		});

		return response; // parses JSON response into native JavaScript objects
	}

/*
 *    let validateEmail = (mail) => {
 *        if (/[^@]+@[^\.]+\..+/.test(mail))
 *            return (true);
 *
 *        return (false);
 *    }
 */

	let handleClose = (event, reason) => {
		if (reason === 'clickaway')
			return;

		setModal (false);
	}

	let handleKeyPress = (event) => {
		if (event.key === 'Enter')
			login ();
	};

	return (
		<Grid container spacing={0}>
			<Snackbar type={type} open={open} message={alertDesc} handleClose={handleClose}/>
			<Grid item xs={8} className="Signup-span">
				<span>Login and start your diagnostic test for free!</span>
			</Grid>
			<Grid item xs={8} className="user-details-form">
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<input placeholder="Email address" className="form-box-large" value={email} onChange={(ev) => setEmail(ev.target.value)} onKeyPress = {handleKeyPress} />
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<input placeholder="Password" type="password" className="form-box-large" value={password} onChange={(ev) => setPassword(ev.target.value)}onKeyPress = {handleKeyPress} />
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={8} className="signup-container">
				{ loading ? <CircularProgress /> : (
				<div className="login-button">
					<Button text="Login" onClick={login} />
				</div>
				)}
			</Grid>
			<Grid item xs={8} className="signup-container">
				<span className="already-have-an-account-text">Forgotten Password?</span>
				<Link href="/classroom/register/olp/verifyEmail" className="login-here-link"> Reset</Link>
			</Grid>
			<Grid item xs={8} className="signup-container">
				<span className="already-have-an-account-text">Don't have an account yet?</span>
				<Link href="/classroom/register/olp/signup" className="login-here-link">Sign Up</Link>
			</Grid>
		</Grid>
	);
}

export default withRouter(Component);
